module.exports = __webpack_public_path__ + "img/mock_test_active.bea8d075.svg";